import _ from 'lodash'
import DataSourceForm from './dataset-data-source-form'

const ColumnForm = DataSourceForm.extend({

	/**
	 * @type {Dataset}
	 */
	model: null,

	showLabel: true,

	showDataset: false,

	/**
	 * #30333 can always add filters to columns
	 *
	 * @override
	 */
	filtersAllowed: _.constant(true),

	showAggregationType: function() {
		// Force "use equation" for calculated table columns since the other
		// aggregation types don't work
		// https://github.com/SpiderStrategies/Scoreboard/issues/37514#issuecomment-842487682
		return this.dataSourceType() === 'basic'
	},

	isOnlyUseEquationAllowed: function() {
		if (this.dataSourceType() === 'calculated') {
			// Force "use equation" for calculated table columns since the other
			// aggregation types don't work
			// https://github.com/SpiderStrategies/Scoreboard/issues/37514#issuecomment-842487682
			return true
		} else {
			return DataSourceForm.prototype.isOnlyUseEquationAllowed.apply(this, arguments)
		}
	}

})

export default ColumnForm

ColumnForm.__filename__ = 'datasets/column-form.js'
